export default "__VITE_ASSET__uUnId3If__"